module.exports = __webpack_public_path__ + "static/media/13.19d8e9a3.png";